import { Unit } from "uom";
export var CelsiusWet = Unit.createBase("CelsiusWet", "WetTemperature", "wb°C");
export var FahrenheitWet = Unit.minus("FahrenheitWet", 32.0, Unit.timesNumber("", 5.0 / 9.0, CelsiusWet));
export var KelvinWet = Unit.minus("KelvinWet", 273.15, CelsiusWet);
//# sourceMappingURL=wet-temperature.js.map